import React, { FC } from 'react';
import { Col, Row } from 'antd';
import PrintForm2 from '../print-form-2';
import ruRU from 'antd/es/locale/ru_RU';
import CmsTable from '../cms-table';
import Button from '../button/button';
import { localize } from '../../helpers';

const CmsTableWithPrint: FC<any> = ({ downloadAll, downloading, downloadAllLoading, withoutScroll, ...props }) => {
    const download = () => props.exportToCSV(props.data);

    return (
        <>
            <CmsTable
                columns={props.columns}
                dataSource={props.data}
                total={props.total}
                scroll={withoutScroll ? undefined : { x: 2000, y: 300 }}
                lang={ruRU}
                type="default"
                size="small"
                translations={props.translations}
                additionalContentToResult={props?.additionalContentToResult}
            />

            {!!props.data?.length && (
                <Row
                    gutter={15}
                    justify="end"
                    className="mt-3"
                >
                    {props.isExportToCSV && (
                        <Col>
                            <Button
                                type="primary"
                                color="gold"
                                onClick={download}
                                loading={downloading}
                            >
                                {localize('button.download', props.translations)}
                            </Button>
                        </Col>
                    )}
                    {downloadAll && (
                        <Col>
                            <Button
                                type="primary"
                                color="gold"
                                onClick={downloadAll}
                                loading={downloadAllLoading || false}
                            >
                                {localize('button.download-all', props.translations)}
                            </Button>
                        </Col>
                    )}
                    <Col>
                        <PrintForm2 {...props} />
                    </Col>
                </Row>
            )}
        </>
    );
};

export default CmsTableWithPrint;
